import InfluencerDiscovery from './influencer-discovery';

export default InfluencerDiscovery;